import React, { useEffect, useState, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminRatePlan,
  initializeRateAdminRatePlanScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminRatePlan,
  deleteRateAdminRatePlan,
  saveRatePlanTableState
} from "../../../redux/actions/RateAdmin/rateadminRatePlan";
import RateAdminRatePlan from '../../../component/RateAdmin/RateAdminRatePlan';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';
function RateAdminRatePlanScreen(props) {
  const {
    fetchRateAdminRatePlan,
    initRateAdminRatePlanScreen,
    showPageLevelLoader,
    rateAdminRatePlanListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminRatePlan,
    isRateAdminRatePlanExportError,
    isRateAdminRatePlanExportSuccess,
    isLoading,
    deleteRateAdminRatePlan,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isRateAdminRatePlanDeleteSuccess,
    isRateAdminRatePlanDeleteError,
    savedTableState,
    saveRatePlanTableState,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminRatePlanScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminRatePlan(savedParams);
    } else {
      fetchRateAdminRatePlan({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminRatePlan(props);
  };
  
  // Callback to save raw table state for restoration after navigation
  const handleTableStateChange = (rawParams) => {
    saveRatePlanTableState(rawParams);
  };
  const handleCreateRateAdminRatePlan = () => {
    navigate(APP_URLS.RATEADMIN_RATE_PLAN.CREATE);
  }
  const editRateAdminRatePlanRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATE_PLAN.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminRatePlan = {
    handleCreateRateAdminRatePlan,
    exportRateAdminRatePlan,
    isRateAdminRatePlanExportError,
    isRateAdminRatePlanExportSuccess,
    editRateAdminRatePlanRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteRateAdminRatePlan,
    isRateAdminRatePlanDeleteSuccess,
    isRateAdminRatePlanDeleteError,
    fetchRateAdminRatePlans: loadLazyData,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    tableData: {
      columns: rateAdminRatePlanListview?.columns,
      rows: rateAdminRatePlanListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminRatePlan
        {...rateAdminRatePlan}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminRatePlanScreen: () => dispatch(initializeRateAdminRatePlanScreen()),
    fetchRateAdminRatePlan: (payload) => dispatch(fetchRateAdminRatePlan(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminRatePlan: (payload) => dispatch(exportRateAdminRatePlan(payload)),
    deleteRateAdminRatePlan: (payload) => dispatch(deleteRateAdminRatePlan(payload)),
    saveRatePlanTableState: (payload) => dispatch(saveRatePlanTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminRatePlanCreateSuccess: selectFromRateAdminRatePlanReducer(
      state,
      "isRateAdminRatePlanCreateSuccess"
    ),
    rateAdminRatePlanListview: selectFromRateAdminRatePlanReducer(
      state,
      "rateAdminRatePlanListview"
    ),
    showPageLevelLoader: selectFromRateAdminRatePlanReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminRatePlanReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminRatePlanReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminRatePlanReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminRatePlanExportError: selectFromRateAdminRatePlanReducer(
      state,
      "isRateAdminRatePlanExportError"
    ),
    isRateAdminRatePlanExportSuccess: selectFromRateAdminRatePlanReducer(
      state,
      "isRateAdminRatePlanExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminRatePlanReducer(state, "shouldOpenDeleteConfirmationPopup"),
    isRateAdminRatePlanDeleteSuccess: selectFromRateAdminRatePlanReducer(state, "isRateAdminRatePlanDeleteSuccess"),
    isRateAdminRatePlanDeleteError: selectFromRateAdminRatePlanReducer(state, "isRateAdminRatePlanDeleteError"),
    isLoading: selectFromRateAdminRatePlanReducer(state, "isLoading"),
    savedTableState: selectFromRateAdminRatePlanReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminRatePlanReducer = (state, path) => {
  return selectRateAdminRatePlanReducer(state)[path];
};

const selectRateAdminRatePlanReducer = ({ rateadminRatePlanReducer }) => {
  return rateadminRatePlanReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminRatePlanScreen);
